import recommendationCarousel from './components/recommendationCarousel';

$(document).ready(function () {
    recommendationCarousel.init();
});
